import { IRowNode } from 'ag-grid-community';
import { VehicleModel } from 'src/app/shared/models/case-creation/vehicle.model';

export function createRowSelectionCallback(selectedVins: string[]): (node: IRowNode<unknown>) => boolean {
  return (node: IRowNode<unknown>) => {
    const vehicleNode = node.data as VehicleModel;
    return selectedVins.includes(vehicleNode.vin);
  };
}

export function sortVinsByDisplayedOrder(selectedVins: string[], displayedVins: string[]): string[] {
  const selectedVinSet = new Set(selectedVins);
  return displayedVins.filter((vin) => selectedVinSet.has(vin));
}
